import { render, staticRenderFns } from "./Prj01Skye.vue?vue&type=template&id=2ea723d0&scoped=true&"
import script from "./Prj01Skye.vue?vue&type=script&lang=js&"
export * from "./Prj01Skye.vue?vue&type=script&lang=js&"
import style0 from "./Prj01Skye.vue?vue&type=style&index=0&id=2ea723d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea723d0",
  null
  
)

export default component.exports